import { ROUTES } from "@/core/router/routes";
import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
// auth
import { GuestGuard } from "@/auth/guard";
// layouts
// components

// ----------------------------------------------------------------------

// JWT
const SignUpPage = lazy(
  () => import("@/features/auth/pages/sign-up/sign-up-page")
);
const SignInPage = lazy(
  () => import("@/features/auth/pages/sign-in/sign-in-page")
);
const VerifyEmailPage = lazy(
  () => import("@/features/auth/pages/verify-email/verify-email-page")
);
const VerifyLoginPage = lazy(
  () => import("@/features/auth/pages/verify-login/verify-login-page")
);
const OAuthCallbackPage = lazy(
  () => import("@/features/auth/pages/oauth-calback/oauth-callback-view")
);

// ----------------------------------------------------------------------

const auth = {
  path: "",
  element: (
    <GuestGuard>
      <Suspense>
        <Outlet />
      </Suspense>
    </GuestGuard>
  ),
  children: [
    {
      path: ROUTES.Auth.SignIn,
      element: <SignInPage />,
    },
    {
      path: ROUTES.Auth.SignUp,
      element: <SignUpPage />,
    },
    {
      path: ROUTES.Auth.VerifyEmail,
      element: <VerifyEmailPage />,
    },
    {
      path: ROUTES.Auth.VerifyLogin,
      element: <VerifyLoginPage />,
    },
    {
      path: ROUTES.Auth.OAuthCallback,
      element: <OAuthCallbackPage />,
    },
  ],
};

export const authRoutes = [
  {
    path: "auth",
    children: [auth],
  },
];
